import React from 'react'
import { Input } from 'components/forms'
import Button from 'src/components/button'
import useConfirmAccount from './hooks/useConfirmAccount'
import * as S from './styles'

const ConfirmAccountForm = ({ email, password, authenticationToken, firstName, lastName, phone, document, birthDate, isMktsrvTermsAccepted, isNewsletterOptIn, successCallback }) => {
  const { form: { errors, register, submitForm, watch }, error } = useConfirmAccount()

  const errorMessage = error ? 'Código inválido' : errors.keyCode?.message ?? ''

  const handleSubmit = (event) => {
    event.preventDefault()
    submitForm({ email, password, authenticationToken, firstName, lastName, phone, document, birthDate, isMktsrvTermsAccepted, isNewsletterOptIn, successCallback })
  }

  return (
    <S.Form onSubmit={handleSubmit}>
      <Input
        value={watch.keyCode}
        hookForm={register('keyCode', { required: true })}
        dataTest='input-access-key-confirm'
        margin='24px 0'
        name='keyCode'
        label='Código de acesso'
        type='text'
        placeholder='Informe o código de acesso recebido'
        errorMessage={errorMessage}
      />
      <Button margin='0' theme='primary' data-test='signup-form-button-confirm' type='submit'>Acessar conta</Button>
    </S.Form>
  )
}

export default ConfirmAccountForm
